/** Display name used when the default Rovo Chat agent metadata is not available. */
export const DEFAULT_AGENT_DISPLAY_NAME = 'Rovo';
